import React from 'react';
import { Button, ModalIsland } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../../utils/localization';

import invertedMessages from './messages';

function LaunchConfirmModal({ isOpen, blockerCount, blockerDetails, onClose }) {
  const l = useInvertedLocalize(invertedMessages);

  const alertTitle = l('Saviynt Security Manager');
  const blockerList = blockerDetails
    .map((b) => `\u2022 ${b.code}: ${b.description}`)
    .join('\n');
  const alertSubtitle = `${l('Launch blocked:')} ${blockerCount} ${l(
    'blocker(s) must be resolved before launching.'
  )}\n${blockerList}`;

  return (
    <ModalIsland
      kind='warning'
      isOpen={isOpen}
      onClose={onClose}
      alertTitle={alertTitle}
      alertSubtitle={alertSubtitle}
      isCloseButtonVisible={false}
      primaryButton={
        <Button type='button' kind='filled' size='medium' onClick={onClose}>
          {l('Close')}
        </Button>
      }
      secondaryButton={null}
    />
  );
}

LaunchConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  blockerCount: PropTypes.number.isRequired,
  blockerDetails: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
    })
  ),
  onClose: PropTypes.func.isRequired,
};

LaunchConfirmModal.defaultProps = {
  blockerDetails: [],
};

export default LaunchConfirmModal;
